import React from "react";
import { Worker, Viewer } from "@react-pdf-viewer/core";
import "@react-pdf-viewer/core/lib/styles/index.css";

const GeneralMaps = () => {
    const pdfFiles = [
        "/DATA/Cyclone/ GeneralMaps/Dili-TL A3 District Map 110813.pdf",

       // "/DATA/Cyclone/GeneralMaps/TL_A3_Base_map_111813.pdf",
        // "/DATA/Cyclone/GeneralMaps/TL-Admin Map A4 111313.pdf",
        // "/DATA/Cyclone/GeneralMaps/Dili-TL A3 District Map 110813.pdf",
        // "/DATA/Cyclone/GeneralMaps/Ailleu-TL A3 District Map 110813.pdf",
        // "/DATA/Cyclone/GeneralMaps/Ainaro-TL A3 District Map 110813.pdf",
        // "/DATA/Cyclone/GeneralMaps/Baucau-TL A3 District Map 110813.pdf",
        // "/DATA/Cyclone/GeneralMaps/Covalima-TL A3 District Map 110813.pdf",
        // "/DATA/Cyclone/GeneralMaps/Ermera-TL A3 District Map 110813.pdf",
        // "/DATA/Cyclone/GeneralMaps/Lautem-TL A3 District Map 110813.pdf",
        // "/DATA/Cyclone/GeneralMaps/Liquica-TL A3 District Map 110813.pdf",
        // "/DATA/Cyclone/GeneralMaps/Manatuto-TL A3 District Map 110813.pdf",
        // "/DATA/Cyclone/GeneralMaps/Manufahi-TL A3 District Map 110813.pdf",
        // "/DATA/Cyclone/GeneralMaps/Oecussi-TL A3 District Map 110813.pdf",
        // "/DATA/Cyclone/GeneralMaps/Viqueque-TL A3 District Map 110813.pdf",
    ];

    return (
        <div style={{ height: "100vh", width: "100%", overflowY: "auto" }}>
            {pdfFiles.map((pdfPath, index) => (
                <div key={index} style={{ marginBottom: "20px" }}>
                    <Worker workerUrl={`https://unpkg.com/pdfjs-dist@3.11.174/build/pdf.worker.min.js`}>
                        <Viewer fileUrl={pdfPath} />
                    </Worker>
                </div>
            ))}
        </div>
    );
};

export default GeneralMaps;